import React, {Fragment, useState} from 'react';
import {Field} from "formik";

const PhoneInput = ({name, value, className, tooltipText, ...props}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleTooltipClick = () => {
    setShowTooltip(!showTooltip)
  };

  return (
      <Fragment>
        {showTooltip &&
            <div className="flex justify-end relative">
              <div className="absolute mx-2 w-32 z-50 -mb-2 bottom-0 -mr-0 sm:-mr-10">
                <div className="bg-tgnavy text-xs rounded p-3 right-0 bottom-full text-white text-center">
                  {tooltipText}
                  <svg className="absolute text-tgnavy h-2 right-0 sm:left-0 top-full mr-3 sm:mr-0 w-auto sm:w-full" x="0px" y="0px" viewBox="0 0 255 255" xmlSpace="preserve">
                    <polygon className="fill-current" points="0,0 127.5,127.5 255,0"/>
                  </svg>
                </div>
              </div>
            </div>
        }
        <div className="relative">
          <Field type="tel" name={name} className={className} {...props} />
          <button onClick={handleTooltipClick} type="button" className="absolute right-0 top-0 mt-4 mr-4 bg-tgnavy px-2 rounded-sm font-bold text-white">?</button>
        </div>
      </Fragment>
  )
}

export default PhoneInput;


// WEBPACK FOOTER //
// ./app/javascript/bundles/checkout/components/phone_input/PhoneInput.jsx